export const EnterToBlurDirective = {
  inserted(el) {
    const input = ['INPUT', 'TEXTAREA'].includes(el.tagName) ? el : el.querySelector('input,textarea');
    if (input) {
      input.addEventListener('keyup', (e) => {
        if (e.key === 'Enter') {
          e.target?.blur();
        }
      });
    }
  }
};

const mockEnterKeyboardEvent = (type) => {
  return new KeyboardEvent(type, {
    altKey: false,
    bubbles: true,
    cancelBubble: false,
    cancelable: true,
    charCode: 0,
    code: 'Enter',
    composed: true,
    ctrlKey: false,
    currentTarget: null,
    defaultPrevented: true,
    detail: 0,
    eventPhase: 0,
    isComposing: false,
    isTrusted: true,
    key: 'Enter',
    keyCode: 13,
    location: 0,
    metaKey: false,
    repeat: false,
    returnValue: false,
    shiftKey: false,
    type: type,
    which: 13
  });
};

export const BlurToEnterDirective = {
  inserted(el) {
    const input = ['INPUT', 'TEXTAREA'].includes(el.tagName) ? el : el.querySelector('input,textarea');
    if (input) {
      input.addEventListener('blur', (e) => {
        e.target?.dispatchEvent(mockEnterKeyboardEvent('keydown'));
        e.target?.dispatchEvent(mockEnterKeyboardEvent('keyup'));
        e.target?.dispatchEvent(mockEnterKeyboardEvent('keypress'));
      });
    }
  }
};
